'use strict';

import { queryFirst } from '../domUtil';

/**
 * Hide the Zendesk chat widget by default. Show and open it when a chat button is clicked.
 */
function chatHideShow() {
    const chatBtnEl = queryFirst('.js-chat-btn');
    const zEScript = queryFirst('#ze-snippet');

    if (chatBtnEl && zEScript) {
        const controlMessenger = (command) => {
            zE('messenger', command);
        };

        controlMessenger('hide');

        chatBtnEl.addEventListener('click', function () {
            controlMessenger('show');
            controlMessenger('open');
        });
    }
}

export default {
    chatHideShow
}
